import { Wayfinding, WayfindingCardArticle, formatDateWithoutTimeZone } from '@cbhq/cdx-components';
import { mapEntryLink } from '../globals/navlink.js';
import { getEntryProps } from '../utils/getEntryProps.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_VIDEO_LIST_CONTENT_MODEL_ID = 'cdxHighlightVideoList';
function HighlightVideoList({
  headline,
  body,
  link,
  style,
  videoList,
  anchor,
  hasSpacingTop = true
}) {
  const _mapEntryLink = mapEntryLink(link),
    url = _mapEntryLink.url,
    label = _mapEntryLink.label;
  return /*#__PURE__*/jsx(Wayfinding, {
    columns: 1,
    headline: headline,
    body: body,
    ctaButtonUrl: url,
    ctaButtonLabel: label,
    style: style,
    anchor: anchor,
    hasSpacingTop: hasSpacingTop,
    children: videoList?.map((entry, index) => {
      const _getEntryProps = getEntryProps(entry, {
          date: '',
          headline: ''
        }),
        headline = _getEntryProps.headline,
        body = _getEntryProps.body,
        mediaUrl = _getEntryProps.mediaUrl,
        thumbnail = _getEntryProps.thumbnail,
        date = _getEntryProps.date,
        readTime = _getEntryProps.readTime,
        link = _getEntryProps.link;
      const _mapEntryLink2 = mapEntryLink(link),
        url = _mapEntryLink2.url;
      return /*#__PURE__*/jsx(WayfindingCardArticle, {
        headline: headline,
        href: url,
        body: body,
        mediaType: "video",
        mediaUrl: mediaUrl,
        readTime: readTime,
        mediaAlt: "placeholder",
        thumbnailUrl: thumbnail?.fields.file.url,
        datePublished: formatDateWithoutTimeZone(date)
      }, index);
    })
  });
}
export { HIGHLIGHT_VIDEO_LIST_CONTENT_MODEL_ID, HighlightVideoList };
//# sourceMappingURL=HighlightVideoList.js.map
